import axios from "axios";
import * as Sentry from "@sentry/react";
import { logApiError, addBreadcrumb } from "./errorLogger";

export const setupAxiosInterceptors = () => {
  axios.interceptors.request.use(
    (config) => {
      addBreadcrumb(
        `API Request: ${config.method?.toUpperCase()} ${config.url}`,
        "http",
        "info",
        {
          url: config.url,
          method: config.method,
        }
      );

      return config;
    },
    (error) => {
      Sentry.captureException(error);
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    (response) => {
      addBreadcrumb(
        `API Response: ${response.status} ${response.config.url}`,
        "http",
        "info",
        {
          status: response.status,
          url: response.config.url,
        }
      );

      return response;
    },
    (error) => {
      logApiError(
        error,
        error.config?.url,
        error.config?.method,
        error.config?.data
      );

      addBreadcrumb(
        `API Error: ${error.response?.status} ${error.config?.url}`,
        "http",
        "error",
        {
          status: error.response?.status,
          url: error.config?.url,
          message: error.message,
        }
      );

      return Promise.reject(error);
    }
  );
};

export default setupAxiosInterceptors;